/**
 * Costanti di brand Susy® — Hub Operativo
 * Allineate al Brand Manual ufficiale.
 */

export const SUSY = {
  brand: 'Susy®',
  brandPlain: 'Susy',
  legalEntity: 'Didò Studio Srl',
  vat: 'IT04560460166',
  /** Sede legale: intestazione delle fatture di partner e creators */
  legalAddress: 'Via Spigla 14, 24020 Cene (BG)',
  /** Codice destinatario SDI per la fattura elettronica */
  sdi: 'M5UXCR1',
  payoff: 'Living your pets',
  concept: 'Il tuo animale domestico è casa',
  hubTitle: 'Susy® · Hub Operativo',
  email: 'info@susy.pet',
  site: 'https://susy.pet',
} as const

// Cookie con lo stato della sidebar desktop ('1' = ridotta a sole icone): letto dal
// layout server per renderizzare subito la larghezza giusta, scritto dal toggle.
export const SIDEBAR_COOKIE = 'sidebar_collapsed'

export const SUSY_COLORS = {
  verdeBosco: '#203d23',
  verdeBoscoDark: '#0e4a27',
  beigeFieno: '#f5e8db',
  linoNaturale: '#fbfaf4',
  nero: '#1a1a1a',
  bianco: '#ffffff',
  grigioTesto: '#444444',
} as const

/** Linee prodotto */
export const PRODUCT_LINES = [
  { slug: 'susy-living-pet', name: 'Susy Living Pet', description: 'Linea arredo (nuova)' },
  { slug: 'linea-storica',   name: 'Linea Storica',   description: 'Prodotti a catalogo 2025' },
] as const
export type ProductLineSlug = typeof PRODUCT_LINES[number]['slug']

/** Canali listino */
export const PRICE_LIST_CHANNELS = [
  { slug: 'b2c_retail',   name: 'B2C Retail',            vatMode: 'incl' as const, note: 'susy.pet + punto vendita' },
  { slug: 'architetti',   name: 'Architetti & Designer', vatMode: 'excl' as const, note: 'Trade −25%' },
  { slug: 'b2b_wholesale',name: 'B2B Wholesale',         vatMode: 'excl' as const, note: '3 scaglioni quantità' },
  { slug: 'hospitality',  name: 'Hospitality',           vatMode: 'excl' as const, note: 'Hotel / B&B −30%' },
  { slug: 'linea_storica',name: 'Linea Storica',         vatMode: 'mixed' as const, note: 'Retail + B2B keystone' },
] as const
export type PriceListChannel = typeof PRICE_LIST_CHANNELS[number]['slug']

/**
 * Enum contact_category del DB — 13 valori, usato su event_attendees.category
 * (dove ha senso taggare un invitato come "lead" / "prospect" all'evento).
 */
/** Stati ordine di acquisto */
export const PO_STATUSES = [
  { slug: 'draft',      name: 'Bozza',        color: '#444444', bg: '#f4f3ed' },
  { slug: 'sent',       name: 'Inviato',      color: '#ffffff', bg: '#c9913c' },
  { slug: 'confirmed',  name: 'Confermato',   color: '#ffffff', bg: '#0e4a27' },
  { slug: 'in_transit', name: 'In transito',  color: '#203d23', bg: '#f5e8db' },
  { slug: 'received',   name: 'Ricevuto',     color: '#ffffff', bg: '#3d8b56' },
  { slug: 'cancelled',  name: 'Annullato',    color: '#ffffff', bg: '#b23a2f' },
] as const
export type POStatusSlug = typeof PO_STATUSES[number]['slug']

/** Categorie costi sostenuti per evento/fiera */
export const EVENT_COST_CATEGORIES = [
  { slug: 'allestimento',           name: 'Allestimento',          color: '#ffffff', bg: '#203d23' },
  { slug: 'catering',               name: 'Catering',              color: '#203d23', bg: '#f5e8db' },
  { slug: 'advertising_digitale',   name: 'Advertising digitale',  color: '#ffffff', bg: '#c9913c' },
  { slug: 'adesione',               name: 'Adesione',              color: '#ffffff', bg: '#0e4a27' },
  { slug: 'affitto_stand',          name: 'Affitto / Stand',       color: '#ffffff', bg: '#3d8b56' },
  { slug: 'marketing_comunicazione',name: 'Marketing & Comunicazione', color: '#ffffff', bg: '#b23a2f' },
  { slug: 'foto_video',             name: 'Foto e video',          color: '#ffffff', bg: '#6b6a5f' },
  { slug: 'altre_spese',            name: 'Altre spese',           color: '#444444', bg: '#f4f3ed' },
] as const
export type EventCostCategorySlug = typeof EVENT_COST_CATEGORIES[number]['slug']

/** Categorie attività per la to-do list interna del team */
export const TASK_CATEGORIES = [
  { slug: 'commerciale',             name: 'Commerciale',              color: '#203d23', bg: '#e6f0e8' },
  { slug: 'marketing_comunicazione', name: 'Marketing & Comunicazione', color: '#c9913c', bg: '#fef3e2' },
  { slug: 'fiera_evento',            name: 'Fiera / Evento',           color: '#0e4a27', bg: '#e6f0e8' },
  { slug: 'ufficio_stampa',          name: 'Ufficio stampa',           color: '#b23a2f', bg: '#fde4d1' },
  { slug: 'ricerca_sviluppo',        name: 'Ricerca & Sviluppo',       color: '#3d8b56', bg: '#eef7f1' },
  { slug: 'produzione',              name: 'Produzione',               color: '#6b6a5f', bg: '#f4f3ed' },
  { slug: 'acquisti',                name: 'Acquisti',                 color: '#8f8d7f', bg: '#f4f3ed' },
  { slug: 'finanza_agevolata',       name: 'Finanza agevolata',        color: '#203d23', bg: '#faf1e7' },
  { slug: 'amministrazione',         name: 'Amministrazione',          color: '#444444', bg: '#f5f2ea' },
] as const
export type TaskCategorySlug = typeof TASK_CATEGORIES[number]['slug']

export const TASK_PRIORITIES = [
  { slug: 'alta',  name: 'Alta',  color: '#ffffff', bg: '#b23a2f' },
  { slug: 'media', name: 'Media', color: '#ffffff', bg: '#c9913c' },
  { slug: 'bassa', name: 'Bassa', color: '#203d23', bg: '#e6f0e8' },
] as const
export type TaskPrioritySlug = typeof TASK_PRIORITIES[number]['slug']

export const TASK_STATUSES = [
  { slug: 'todo',         name: 'Da fare',     color: '#203d23', bg: '#f5e8db' },
  { slug: 'in_progress',  name: 'In corso',    color: '#c9913c', bg: '#fef3e2' },
  { slug: 'done',         name: 'Completata',  color: '#3d8b56', bg: '#e6f0e8' },
  { slug: 'blocked',      name: 'Bloccata',    color: '#b23a2f', bg: '#fde4d1' },
  { slug: 'cancelled',    name: 'Annullata',   color: '#6b6a5f', bg: '#f4f3ed' },
] as const
export type TaskStatusSlug = typeof TASK_STATUSES[number]['slug']

export const CONTACT_CATEGORIES = [
  { slug: 'lead',       name: 'Lead' },
  { slug: 'prospect',   name: 'Prospect' },
  { slug: 'cliente',    name: 'Cliente' },
  { slug: 'fornitore',  name: 'Fornitore' },
  { slug: 'produttore', name: 'Produttore' },
  { slug: 'partner',    name: 'Partner' },
  { slug: 'press',        name: 'Press / Media' },
  { slug: 'architetto',   name: 'Architetto / Designer' },
  { slug: 'buyer',        name: 'Buyer / Rivenditore' },
  { slug: 'ambassador',   name: 'Ambassador / Creator' },
  { slug: 'fiera_evento', name: 'Fiera / Evento' },
  { slug: 'privato',      name: 'Privato' },
  { slug: 'interno',      name: 'Interno' },
  { slug: 'altro',        name: 'Altro' },
] as const
export type ContactCategory = typeof CONTACT_CATEGORIES[number]['slug']

/**
 * Categorie usate per aziende e contatti (dimensione anagrafica).
 * Sottoinsieme di contact_category escludendo gli stati del funnel
 * (lead/prospect/cliente/fornitore/interno) che vivono come TAG.
 */
export const CLIENT_CATEGORIES = [
  { slug: 'partner',    name: 'Partner' },
  { slug: 'press',        name: 'Press / Media' },
  { slug: 'architetto',   name: 'Architetto / Designer' },
  { slug: 'buyer',        name: 'Buyer / Rivenditore' },
  { slug: 'ambassador',   name: 'Ambassador / Creator' },
  { slug: 'produttore',   name: 'Produttore' },
  { slug: 'fiera_evento', name: 'Fiera / Evento' },
  { slug: 'privato',      name: 'Privato' },
  { slug: 'altro',        name: 'Altro' },
] as const
export type ClientCategory = typeof CLIENT_CATEGORIES[number]['slug']

/** Sottoinsieme valido per le AZIENDE (niente "privato" che è solo per contatti) */
export const COMPANY_CATEGORIES = CLIENT_CATEGORIES.filter(c => c.slug !== 'privato')
export type CompanyCategory = typeof COMPANY_CATEGORIES[number]['slug']

/**
 * Tag "stato" del cliente nel funnel / relazione con Susy.
 * Salvati in clients.tags (text[]) — libero di aggiungere tag custom ma
 * questi sono suggeriti e filtrabili.
 */
export const CLIENT_TAGS = [
  { slug: 'lead',      name: 'Lead',      color: '#444444', bg: '#e8e6dd' },
  { slug: 'prospect',  name: 'Prospect',  color: '#203d23', bg: '#f5e8db' },
  { slug: 'cliente',   name: 'Cliente',   color: '#ffffff', bg: '#203d23' },
  { slug: 'fornitore', name: 'Fornitore', color: '#ffffff', bg: '#6b6a5f' },
  { slug: 'interno',   name: 'Interno',   color: '#ffffff', bg: '#0e4a27' },
] as const
export type ClientTag = typeof CLIENT_TAGS[number]['slug']

/** Tier programma creator */
export const CREATOR_TIERS = [
  { level: 1, name: 'Tier 1 — Entry',     commission: 0.08 },
  { level: 2, name: 'Tier 2 — Performer', commission: 0.12 },
  { level: 3, name: 'Tier 3 — Ambassador',commission: 0.18 },
] as const
